// extracted by mini-css-extract-plugin
export default {"shopPage":"ShopPage_shopPage__7MeFp","itemList":"ShopPage_itemList__p2jD9","backdrop":"ShopPage_backdrop__J0CxH"};